import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '../../translate/translate.module';
import {
  ButtonDropdownModule,
  ButtonModule,
  FormElementsModule,
  ModalDialogLayoutModule,
  PagingControlModule,
} from '@lib/ui';
import { BarRatingModule } from 'ngx-bar-rating';
import { FormattedTextViewerModule, ListItemsTableModule } from '@modules';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { NotificationsModule } from '@lib/notifications';
import { ModalSendDocumentsComponent } from './modal-send-documents.component';
import { IconsModule } from '@lib/icons';

@NgModule({
  declarations: [ModalSendDocumentsComponent],
  imports: [
    CommonModule,
    TranslateModule,
    ModalDialogLayoutModule,
    FormElementsModule,
    ButtonModule,
    BarRatingModule,
    IconsModule,
    ListItemsTableModule,
    ButtonDropdownModule,
    NotificationsModule,
    PagingControlModule,
    MatProgressSpinnerModule,
    FormattedTextViewerModule,
  ],
  exports: [ModalSendDocumentsComponent],
})
export class ModalSendDocumentsModule {}
